<template>
    <div class="grid grid-cols-3 gap-2 sm:grid-cols-2 md:gap-8">
        <span class="col-span-1 m-0 text-xs font-normal capitalize text-openhours-day-c">{{ isMobile ? props.dayName.slice(0, 2).toUpperCase() : props.dayName }}</span>
        <span class="col-span-2 my-0 text-xs font-normal text-openhours-time-c sm:col-span-1">{{ `${morningTimeFormatted} - ${afternoonTimeFormatted}` }}</span>
    </div>
</template>

<script setup lang="ts">
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import { DateTime } from 'luxon';
import { computed } from 'vue';

const props = defineProps({
    dayName: {
        type: String,
        required: true,
    },
    morningTime: {
        type: Number,
        required: true,
    },
    afternoonTime: {
        type: Number,
        required: true,
    },
});

const breakpoints = useBreakpoints(breakpointsTailwind);
const isMobile = breakpoints.smaller('sm');

const morningTimeFormatted = computed(() => {
    return DateTime.fromObject({ hour: Math.floor(props.morningTime / 60), minute: props.morningTime % 60 }).toFormat('HH:mm');
});

const afternoonTimeFormatted = computed(() => {
    return DateTime.fromObject({ hour: Math.floor(props.afternoonTime / 60), minute: props.afternoonTime % 60 }).toFormat('HH:mm');
});
</script>
